import { link } from "fs";
import { ISeo } from "interfaces/intarfaces";
import React from "react";
import { Helmet } from "react-helmet";

export const HeaderSEO: React.FC<ISeo> = ({
  title: title_txt = "Hospi housing | Utrecht",
  keywords = "Always wanted to become a host? Hospi housing links (international) students to local hosts and provides a unique experience for both.",
  description = "Become a host, Student in home, Host",
  canonicallink = "https://hospihousing.com",
}) => {
  { console.log(canonicallink) }
  return (

    <Helmet>
      {title_txt && !!title_txt.length && <title>{title_txt}</title>}
      {keywords && !!keywords.length && (
        <meta name="keywords" content={keywords} />
      )}
      {description && !!description.length && (
        <meta name="description" content={description} />
      )}

      {canonicallink && !!canonicallink.length && (
        <link rel="canonical" href={canonicallink} />
      )
      }

    </Helmet>
  );
};
